import { Col, Container, Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import clsx from 'clsx';
import { toPlainText } from '@portabletext/react';
import { HeroQuotes as HeroQuotesProps, SanityKeyed } from 'types/studio/studio';
import { navigationClickEvent } from 'analytics/events/studio';
import { useState } from 'react';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import styles from './HeroQuotes.module.scss';
import CustomPortableText from '../PortableText/PortableText';
import HeroQuotesContent from './HeroQuotesContent/HeroQuotesContent';
import { CommonSectionProps } from '../types';

const HeroQuotes = (props: SanityKeyed<HeroQuotesProps> & CommonSectionProps) => {
  const {
    _key: key,
    _type: sectionType,
    headline,
    quotesList,
    bgColor,
    padding,
    theme,
    footnote,
    visibleOnPageLoad
  } = props;
  const [activeTab, setActiveTab] = useState<string | null>(
    quotesList && quotesList[0] ? quotesList[0]._key : null
  );

  const handleTabClick = (id: string, tabHeadline: string) => {
    setActiveTab(id);
    navigationClickEvent({
      location: sectionType,
      navigationType: 'carousel',
      clickText: tabHeadline,
      header: headline ? toPlainText(headline) : ''
    });
  };

  return (
    <div className={bgColor === 'stone' ? styles.stone : ''}>
      <Container narrow id={key}>
        <Space
          top={{ xxs: 40, s: 60, m: 80, l: 100 }}
          bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
          className={clsx(getSectionPaddingClasses(styles, padding))}>
          {headline && (
            <Col span={{ xxs: 12, l: 5 }} noGutter>
              <Typography
                variant="headlineSans"
                size="2"
                noPadding
                color={getTypographyDefaultColor(theme)}>
                <CustomPortableText value={headline} tag="h2" />
              </Typography>
            </Col>
          )}
          <HeroQuotesContent
            quotesList={quotesList}
            theme={theme}
            activeTab={activeTab}
            bgColor={bgColor}
            onTabClick={handleTabClick}
            visibleOnPageLoad={visibleOnPageLoad}
          />
          {footnote && (
            <Typography
              variant="portalCaption"
              size="2"
              color="grey-1-new"
              noPadding
              className={styles.footnote}>
              <CustomPortableText value={footnote} />
            </Typography>
          )}
        </Space>
      </Container>
    </div>
  );
};

export default HeroQuotes;
